export const KATEX_URL = '//e7n.s3.yandex.net/static/katex/katex.min.js';
export const KATEX_CSS = '//e7n.s3.yandex.net/static/katex/katex.min.css';
